import moment from "moment-timezone"
import { SPORTS, nextSeason, seasonBeingPlanned, seasonOfDay } from "./plannerQuery"

// „Generarea propunerilor” (wayfinder ticket 17): what a run asks the generation preview (Phase D3). Two modes on the same period: by
// organizer (organizer + period, both sports) or by period (country, sports, an optional category and region). The period is a season by
// start date — summer 1 Apr – 31 Oct, winter 1 Nov – 31 Mar — or a free range of at most 12 months; 1, 2 or 3 seasons back.

export const MODES = [["organizer", "By organizer"], ["period", "By period"]]
export const SEASONS_BACK = [1, 2, 3]
// The operational regions of Romania, as the clubs' county gives them (sportya-api `common/operationalRegions`).
export const REGIONS = ["Banat", "Bucuresti", "Dobrogea", "Moldova", "Muntenia", "Oltenia", "Transilvania"]

const DAY = "YYYY-MM-DD"
const validDay = value => moment.utc(value, DAY, true).isValid()
// A season's own days, both included: Winter 2026/27 is 1 Nov 2026 – 31 Mar 2027.
export const seasonPeriod = season => {
  const [kind, year] = season.split("-")
  return kind === "winter" ? { from: `${year}-11-01`, to: `${Number(year) + 1}-03-31` } : { from: `${year}-04-01`, to: `${year}-10-31` }
}
// The season a day falls in ("winter-2026" for 15 Jan 2027).
export const seasonOf = day => {
  const year = Number(day.slice(0, 4))
  if (seasonOfDay(day) === "summer") return `summer-${year}`
  return Number(day.slice(5, 7)) >= 11 ? `winter-${year}` : `winter-${year - 1}`
}
// The seasons a run offers: the one in progress, the one being planned and the next (Summer 2026, Winter 2026/27, Summer 2027 on 21 Oct 2026).
export const seasonChoices = today => {
  const planned = seasonBeingPlanned(today)
  return [...new Set([seasonOf(today), planned, nextSeason(planned)])]
}

// A run's first form: the Events Planner's country and season (the season being planned when the planner shows another), both sports.
export const newGenerationForm = (planner, today) => {
  const seasons = seasonChoices(today)
  const season = seasons.includes(planner.season) ? planner.season : seasonBeingPlanned(today)
  return { mode: "organizer", country: planner.country, organizer: null, periodKind: "season", season, ...seasonPeriod(season), seasonsBack: 1,
    sports: [...SPORTS], category: "", region: "" }
}

// The run's period: the season's own days, or the range typed.
export const periodOf = form => (form.periodKind === "season" ? seasonPeriod(form.season) : { from: form.from, to: form.to })
// What the form refuses before asking: an organizer by organizer, a sport by period, a range of days in order within 12 months.
export const generationErrors = form => {
  const errors = {}
  if (form.mode === "organizer" && !form.organizer) errors.organizer = "Choose the organizer."
  if (form.mode === "period" && !form.sports.length) errors.sports = "Choose at least one sport."
  if (form.periodKind === "range") {
    if (!validDay(form.from)) errors.from = "Choose the first day."
    if (!validDay(form.to)) errors.to = "Choose the last day."
    if (!errors.from && !errors.to) {
      if (form.to < form.from) errors.to = "The period ends after it starts."
      else if (form.to >= moment.utc(form.from, DAY).add(1, "year").format(DAY)) errors.to = "A run covers at most 12 months."
    }
  }
  return errors
}
// The preview's body without the review's choices (Phase D3): the country, the period, the seasons back and the scope.
export const generationRequest = form => ({
  country: form.country, ...periodOf(form), seasonsBack: form.seasonsBack,
  ...(form.mode === "organizer" ? { organizerId: form.organizer.id } : {
    sportType: form.sports, ...(form.category && { category: [form.category] }), ...(form.region && { region: [form.region] }),
  }),
})
